/**
 * Parse patient-facing slot strings like "10:30 AM · Apollo Clinic"
 * or "10:30 AM · OPD · Cardiology" (middle dot separator).
 */

/** Same rules as backend `normalizeBookingSlotKeyPart` so UI keys match GET slots / POST book. */
export function normalizeBookingSlotKeyPart(value) {
  return String(value || "")
    .trim()
    .replace(/\p{Cf}/gu, "")
    .replace(/\s+/g, " ")
    .replace(/[\u00B7\u2022\u2219\u2024\u2981\u30FB\u2027]/g, "\u00B7");
}

export function bookingSlotMapKey(dateKey, timeSlotish) {
  return `${String(dateKey || "").trim()}|${normalizeBookingSlotKeyPart(timeSlotish)}`;
}

export function parseTimeSlotDisplay(timeSlotDisplay) {
  const raw = String(timeSlotDisplay || "").trim();
  if (!raw) return { timePart: "", clinicLabel: "" };
  const parts = raw.split(/[·•]/).map((p) => p.trim()).filter(Boolean);
  if (parts.length >= 2) {
    return { timePart: parts[0], clinicLabel: parts.slice(1).join(" · ").trim() };
  }
  return { timePart: raw, clinicLabel: "" };
}

/** Prefer API `clinicName` / `timePart`; fall back to parsing `timeSlot`. */
export function slotTimePart(slot) {
  if (!slot) return "";
  const t = String(slot.timePart || "").trim();
  if (t) return t;
  return parseTimeSlotDisplay(slot.timeSlot).timePart || String(slot.timeSlot || "").trim();
}

export function slotClinicLabel(slot) {
  if (!slot) return "";
  const c = String(slot.clinicName || "").trim();
  if (c) return c;
  return parseTimeSlotDisplay(slot.timeSlot).clinicLabel;
}

/** For saved appointments: use stored clinicName or parse from timeSlot. */
export function appointmentClinicLabel(appointment) {
  if (!appointment) return "";
  const direct = String(appointment.clinicName || "").trim();
  if (direct) return direct;
  const ts = String(appointment.doctorProposedTimeSlot || appointment.timeSlot || "").trim();
  return parseTimeSlotDisplay(ts).clinicLabel;
}

export function appointmentTimePart(appointment) {
  if (!appointment) return "";
  const ts = String(appointment.doctorProposedTimeSlot || appointment.timeSlot || "").trim();
  return parseTimeSlotDisplay(ts).timePart || ts;
}
